import { Build } from '@stencil/core';

interface KeyAccountOrderChannels {
  webOrder?: {
    editor?: string;
  };
  desktopOrder?: {
    windows?: string;
    mac?: string;
    linux?: string;
  };
  mobileOrder?: {
    ios?: string;
    android?: string;
  };
}

interface KeyAccountsLanguageOrderChannels {
  [keyAccount: string]: {
    [language: string]: KeyAccountOrderChannels;
  };
}

class OrderChannelResolver {
  private apiOrderChannelsPath: string;
  private productId: number;
  private keyAccount: number;
  private project: string;
  private language: string;
  private country: string;
  private fetchResponseCache: KeyAccountsLanguageOrderChannels;

  constructor(
    apiOrderChannelsPath: string,
    productId: number,
    keyAccount: number,
    project: string,
    language: string,
    country: string,
  ) {
    this.apiOrderChannelsPath = apiOrderChannelsPath;
    this.productId = productId;
    this.keyAccount = keyAccount;
    this.project = project;
    this.language = language;
    this.country = country;
  }

  public async resolve(): Promise<KeyAccountsLanguageOrderChannels> {
    if (this.fetchResponseCache) {
      if (Build.isDev) {
        console.debug('OrderChannelsResolver cache is active');
      }
      return this.fetchResponseCache;
    }

    const search = new URLSearchParams({
      productId: `${this.productId}`,
      keyAccount: `${this.keyAccount}`,
      project: this.project,
      language: this.language,
      country: this.country,
    }).toString();

    if (isNaN(this.productId)) {
      console.error('OrderChannelResolver: wrong typed productId');
      return {};
    }

    const url = `${this.apiOrderChannelsPath}/products/${this.productId}.json?${search}`;
    try {
      const response = await fetch(url);
      this.fetchResponseCache = await response.json();
      return this.fetchResponseCache;
    } catch (error) {
      console.error(`OrderChannelResolver: Data of endpoint (${url}) not reachable`, error);
      return {};
    }
  }
}

export default OrderChannelResolver;
export { KeyAccountOrderChannels, KeyAccountsLanguageOrderChannels };
